import clsx from 'clsx';
import { ButtonProps, OverlayTrigger, Tooltip } from 'react-bootstrap';
import './CustomIconButton.scss';
import { Placement } from '@popperjs/core';

type Props = ButtonProps & {
	children: JSX.Element;
	onClick: (e: any) => void;
	variant: 'delete' | 'edit';
	title?: string;
	tooltipPlacement?: Placement;
};

const renderTooltip = (title: string) =>
	title ? <Tooltip className="button-tooltip">{title}</Tooltip> : <></>;

const CustomIconButton = ({
	children,
	onClick,
	variant,
	title,
	tooltipPlacement,
	disabled,
	className,
	...props
}: Props) => {
	const fieldClassName = clsx(
		'btn btn-flush custom-icon-button spaces mx-2',
		variant,
		className,
		{
			'pe-none cursor-none': disabled,
		}
	);

	return (
		<>
			{children && title ? (
				<OverlayTrigger
					rootClose
					delay={{ show: 0, hide: 0 }}
					overlay={renderTooltip(title)}
					placement={tooltipPlacement}
				>
					<button
						className={fieldClassName}
						onClick={onClick}
						type="button"
						{...props}
					>
						{children}
					</button>
				</OverlayTrigger>
			) : (
				<button
					className={fieldClassName}
					onClick={onClick}
					type="button"
					{...props}
				>
					{children}
				</button>
			)}
		</>
	);
};

export default CustomIconButton;
